import { InputSummary } from '../../input-summary';
import InputSummaryUtils from '../../../helper/input-summary/input-summary-util';
import { UnitValue } from '../../data-structures/unit-value.model';
import {v4 as uuid} from 'uuid';
import AnessaListItemUtil, { AnessaListItem } from '../../anessa-list-item.interface';


export interface FinancialIncomeInterface {
  name: string;
  uuid: string;
  description: string;
  income: UnitValue;
  period: UnitValue;
  cpi: UnitValue;
}

export class FinancialIncome implements AnessaListItem {
  name: string;
  uuid: string;
  description: string;
  income: UnitValue;
  period: UnitValue;
  cpi: UnitValue;

  constructor(param: FinancialIncomeInterface = {
    name: '',
    uuid: null,
    description: '',
    income: new UnitValue(),
    period: new UnitValue(),
    cpi: new UnitValue()
  }) {
    this.name = param.name;
    this.uuid = param.uuid ? param.uuid : uuid();
    this.description = param.description;
    this.income = new UnitValue(param.income);
    this.period = new UnitValue(param.period);
    this.cpi = new UnitValue(param.cpi);
  }

  static deepCopy(income) {
    let copy;
    if (income) {
      copy = new FinancialIncome(income);
      return copy;
    }
    throw new Error('Financial income copy failed');
  }

  getInputSummary(path: string[]) {
    const inputSummary = new InputSummary();
    inputSummary.inputs = InputSummaryUtils.performPush(inputSummary.inputs, FinancialIncomePropName.description, this.description, [...path, 'description']);
    inputSummary.inputs = InputSummaryUtils.performPush(inputSummary.inputs, FinancialIncomePropName.income, this.income, [...path, 'income']);
    inputSummary.inputs = InputSummaryUtils.performPush(inputSummary.inputs, FinancialIncomePropName.period, this.period, [...path, 'period']);
    inputSummary.inputs = InputSummaryUtils.performPush(inputSummary.inputs, FinancialIncomePropName.cpi, this.cpi, [...path, 'cpi']);
    return inputSummary;
  }

  getUuidForPath(): string {
    return AnessaListItemUtil.getUuidForPath(this.uuid);
  }
}

export enum FinancialIncomePropName {
  name = 'INPUT_SUMMARY.FINANCIAL.NAME',
  description = 'INPUT_SUMMARY.FINANCIAL.DESCRIPTION',
  income = 'INPUT_SUMMARY.FINANCIAL.INCOME.INCOME',
  period = 'INPUT_SUMMARY.FINANCIAL.PERIOD',
  cpi = 'INPUT_SUMMARY.FINANCIAL.CPI',
  id_name = 'name',
  id_income = 'income',
  id_period = 'period',
  id_cpi = 'CPI',
}

export enum FinIncomeErrorMessage {
  MissingName = 'INPUT_SUMMARY.FINANCIAL.INCOME.MISSING_NAME',
}
